import React from 'react';
import styled from 'styled-components';
import { space } from 'styled-system';

const List = styled.ul`
  ${space}

  & > li:last-child {
    border-bottom: 0px;
  }
`;

export default function CustomList({ style, children }) {
  return <List {...style}>{children}</List>;
}
